module.exports = __webpack_public_path__ + "img/chatkeeper-logo.70feb94f.png";